"use strict";

var PropTypes = require("prop-types");

var LoggerInstance = require("js-logger").get("RecurringUpsellCheckbox");

var ProjectActions = require("./ProjectActions");
var ProjectConstants = require("./ProjectConstants");
var ProjectStore = require("./ProjectStore");

var VisibilityStore = require("../client/VisibilityStore");

class RecurringUpsellCheckbox extends React.Component {
	constructor(props) {
		super(props);

		var upsell = !!props.defaultChecked;
		var project = ProjectStore.get("project") || props.project || {};
		project = JSON.parse(JSON.stringify(project)); // clone the project to avoid reference
		var tangibleCode;

		if (props.isDesignMode) {
			if (!project) {
				project = {
					projectCode: "DESIGN01",
					description: "test description"
				};
			}
		}

		if (props.context) {
			if (props.project) {
				tangibleCode = props.project.tangibleCode;
			} else if (props.isDesignMode) {
				tangibleCode = project["ProjectCode"];
			}
		}

		this.state = {
			upsell,
			tangibleCode
		};

		this._onChange = this._onChange.bind(this);
	}

	handleRecurringUpsellChange(event) {
		var checked = event.target.checked;

		ProjectActions.setUpsell(checked, this.state.tangibleCode, this.props.pledgeCode, this.state.context);
	}

	elementsToShowHide(contextId, $context) {
		if (contextId) {
			var $recurringUpsell = $(ReactDOM.findDOMNode(this));
			return $recurringUpsell.closest("[data-component='category.pledge'],[data-component='category.project'],[data-component='searchResults.pledge'],[data-component='searchResults.project']").find("[data-component$='.recurringUpsell']");
		}
		return $context.find("[data-component$='.recurringUpsell']").not("[data-component='category.pledge'] [data-component$='.recurringUpsell'],[data-component='category.project'] [data-component$='.recurringUpsell'],[data-component='searchResults.pledge'] [data-component$='.recurringUpsell'],[data-component='searchResults.project'] [data-component$='.recurringUpsell']");
	}

	_onChange() {
		this.setState(ProjectStore.getState());
	}

	componentDidMount() {
		if (this.props.isDesignMode) {
			//To add or remove react components from window, edit wwwroot\js\designer\ExposedComponents.jsx
			parent.window.ComponentActions.childComponentLoaded(this);
		}
		var $recurringUpsell = $(ReactDOM.findDOMNode(this));
		var tangibleCode = this.state.tangibleCode;
		var { context, pledgeCode } = this.props;

		var ruleIdentifier;
		var contextId = "";

		if (context) {
			contextId = this.getContextId($recurringUpsell, context);
			context = this.getUpdatedContext(context);

			context += `_${contextId}`;
			ruleIdentifier = `recurringUpsellCheckbox_${context}_${tangibleCode}`;

			if (pledgeCode) {
				ruleIdentifier = `${ruleIdentifier}_${pledgeCode}`;
			}

		} else {
			ruleIdentifier = "recurringUpsellCheckbox";
		}

		$recurringUpsell.closest("[data-component$=recurringUpsell]").children("[data-component$='recurringUpsell.label']").attr("for", ruleIdentifier);
		if (typeof ($) !== "undefined") {
			if (!VisibilityStore.hasRule(ruleIdentifier)) {
				VisibilityStore.addRule({
					identifier: ruleIdentifier,
					triggers: [ProjectConstants.SET_USE_ON_DAY, ProjectConstants.SET_DONATION_FREQUENCY, ProjectConstants.SET_RECURRING_START_DATE],
					shouldTrigger: (action) => {
						// Sub-criteria, cannot rely on SET_DONATION_FREQUENCY or SET_USE_ON_DAY or SET_RECURRING_START_DATE
						// coersion because certain actions were passing null for context and tangible code, while local values are undefined.
						return action.context == context &&
							action.tangibleCode == tangibleCode &&
							(!pledgeCode || (!action.context || (action.pledgeCode && action.pledgeCode == pledgeCode)));
					},
					show: (action) => {
						var startDate = ProjectStore.getCalculatedStartDate(context, tangibleCode, pledgeCode);
						return !window.moment().isSame(startDate, "d") && ProjectStore.getSelectedFrequency(context, tangibleCode, pledgeCode) !== "O";
					},
					elements: this.elementsToShowHide.bind(this, contextId),
					initialize: () => {
						var startDate = ProjectStore.getCalculatedStartDate(context, tangibleCode, pledgeCode);
						return !window.moment().isSame(startDate, "d") && ProjectStore.getSelectedFrequency(context, tangibleCode, pledgeCode) !== "O";
					}
				});
			}
		}

		var selectedUpsell = this.state.upsell;
		if (!context) {
			var cachedValues = {};
			if (ProjectActions.getCachedValues) {
				cachedValues = ProjectActions.getCachedValues() || {};
			}

			selectedUpsell = cachedValues.isRecurringUpsell !== undefined ? cachedValues.isRecurringUpsell : this.state.upsell;
		}

		this.setState({ context, ruleIdentifier }, () => {
			// At this point, upsell has been set by the component
			// This has to happen here so the onChange below is invoked
			ProjectActions.setUpsell(selectedUpsell, tangibleCode, pledgeCode, context);
		});
		ProjectStore.addChangeListener(this._onChange);
	}

	getContextId($component, context) {
		if (!context) {
			return;
		}

		switch (context) {
			case "tangible":
				return $component.closest("[data-component=category]").attr("id");
			case "result":
				return $component.closest("[data-component=searchResults]").attr("id");
		}
	}

	getUpdatedContext(context) {
		if (!context) {
			return;
		}

		switch (context) {
			case "tangible":
				return "category";
			case "result":
				return "search";
		}
	}

	componentWillUnmount() {
		var { context, tangibleCode, ruleIdentifier } = this.state;
		var { pledgeCode } = this.props;

		VisibilityStore.removeRule(ruleIdentifier);
		ProjectStore.removeChangeListener(this._onChange);

		if (this.props.isDesignMode) {
			//To add or remove react components from window, edit wwwroot\js\designer\ExposedComponents.jsx
			parent.window.ComponentActions.childComponentUnloaded(this);
			ProjectActions.setUpsell(false, tangibleCode, pledgeCode, context);
		}
	}

	render() {
		var { context, tangibleCode, ruleIdentifier } = this.state;
		var { pledgeCode, isDesignMode } = this.props;

		var upsell = context ? ProjectStore.getSelectedUpsell(context, tangibleCode, pledgeCode) : this.state.upsell;

		var hasPremium = ProjectStore.getSelectedPremium(context, tangibleCode);
		var isChargeTodayRequired = ProjectStore.getIsChargeTodayRequired() || (hasPremium && ProjectStore.getIsChargeTodayRequiredOnlyWithPremium());

		var isChecked = Boolean(upsell || isChargeTodayRequired);

		return (
			<span
				data-react-component-name="RecurringUpsellCheckbox"
				data-react-component-category="ProjectComponents"
				data-component-id={this.props.dataComponentId}
				data-nested-id={this.props.dataNestedId}
				data-repeated-id={this.props.dataRepeatedId}
				data-theme={+this.props.theme ? this.props.theme : undefined}
				data-custom={this.props.isCustomTheme || null}
				data-child-of={this.props.dataChildOf}
			>
				<input type="checkbox" checked={isChecked} id={ruleIdentifier} onChange={this.handleRecurringUpsellChange.bind(this)} disabled={!isDesignMode && isChargeTodayRequired} />
			</span>
		);
	}
}

RecurringUpsellCheckbox.defaultProps = {};

RecurringUpsellCheckbox.propTypes = {
	isDesignMode: PropTypes.bool,
	pledgeCode: PropTypes.string,
	project: PropTypes.object,
	context: PropTypes.string,
	dataRepeatedId: PropTypes.string
};

module.exports = RecurringUpsellCheckbox;
